export const ClaimFormStepsEnum = {
  ClaimType: 'claim-type',
  ApplianceDetails: 'appliance_details',
  ContactDetails: 'contact_details',
  FaultQuestions: 'fault_questions',
  ServiceOptions: 'service_options',
  VisitAppointment: 'visit_appointment',
  VisitBooked: 'visit_booked',
  InitialVisitAppointment: 'initial_visit_appointment',
} as const;

type enumKeys = keyof typeof ClaimFormStepsEnum;
export type ClaimFormStep = (typeof ClaimFormStepsEnum)[enumKeys];
